type OS = 'ios' | 'android' | 'unknown'

export function getMobileOperatingSystem(): OS {
    // @ts-expect-error window api
    const userAgent = navigator.userAgent || navigator.vendor || window.opera

    if (/android/i.test(userAgent)) {
        return 'android'
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    // @ts-expect-error window api
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return 'ios'
    }

    return 'unknown'
}

export type Config = {
    function: 'openExternalLink'
    arguments: {
        link: string
    }
}

/** Function for call native methods */
export async function sendWindowMessage(config: Config) {
    try {
        const os = getMobileOperatingSystem()

        if (os === 'ios') {
            // @ts-expect-error window api
            window.webkit.messageHandlers[config.function].postMessage(
                JSON.stringify(config)
            )
        }

        if (os === 'android') {
            // @ts-expect-error window api
            window[config.function].postMessage(JSON.stringify(config))
        }
    } catch {
        console.warn(`CustomError: sendWindowMessage function is failure.`)
    }
}
